export function translateTextWithParam(translationText, options) {
  if (!options) return translationText;
  const optionsMap = {};
  for (const option in options) {
    if ({}.hasOwnProperty.call(options, option)) {
      optionsMap[`{{ ${option} }}`] = options[option];
      optionsMap[`{{${option}}}`] = options[option];
    }
  }
  let newText = '';
  let tempStr = '';
  for (let i = 0; i < Number(translationText.length); i++) {
    if (translationText.charAt(i) === '{' && i - 1 < translationText.length && translationText.charAt(i + 1) === '{' && !tempStr.length) {
      tempStr = '{';
      continue;
    }
    if (translationText.charAt(i) === '}' && i + 1 < translationText.length && translationText.charAt(i + 1) === '}' && !!tempStr.length) {
      i++;
      tempStr = `${tempStr}}}`;
      if (optionsMap[tempStr]) {
        newText = `${newText}${optionsMap[tempStr]}`;
      }
      tempStr = '';
      continue;
    }
    if (tempStr.length) {
      tempStr = `${tempStr}${translationText.charAt(i)}`;
      continue;
    }
    newText = `${newText}${translationText.charAt(i)}`;
  }
  return `${newText}${tempStr}`;
}